// extracted by mini-css-extract-plugin
module.exports = {"text-with-point-section":"TextWithPointsSection_text-with-point-section__F74Pu"};